<template>
<div>
  <ul class="list-group">
    <li class="list-group-item" v-for="wallet in paymentMethods.wallets">
      <div class="segments" id="wallets">
        <div class="item">
        <img src="../../../static/img/wallets/lajanCash.png" class="img-responsive" width="90" height="60" style="margin-left:-14px;"/>
        </div>
        <div class="item"><br>{{wallet.phoneNumber}}</div>
        <!--<div class="item"><br>{{wallet.balance}} {{wallet.currency}}</div>-->
        <div class="item"><br><a href="#"><i class="fa fa-heart" style="color: pink; font-size:18px;"></i></a></div>
        <div class="item"><br><a href="#"><i class="fa fa-trash" style="color: red; font-size:18px;" @click.prevent="deleteWallet(wallet.id)"></i></a></div>
      </div>
        <div class="row">
          <div class="col-lg-6 col-md-6">
              <div class="card-box tilebox-two tilebox-primary" style="border-left-color: #188ae2">
                  <a href="#" title="Add money to Lajancash wallet" class="pull-right">
                      <svg class="add-money-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 32" width="65px" height="45px" fill="#20BFD6">
                          <g>
                              <path class="add-money-icon-stroke" d="M34.41,2.57a6.1,6.1,0,0,0-6.13,6.06,6.14,6.14,0,0,0,12.27,0A6.1,6.1,0,0,0,34.41,2.57Zm0,11.11a5.1,5.1,0,0,1-5.13-5.06,5.14,5.14,0,0,1,10.27,0A5.1,5.1,0,0,1,34.41,13.68Z"></path>
                              <path class="cls-1" d="M36.85,8.12H34.91V6.18a.5.5,0,0,0-1,0V8.12H32a.5.5,0,0,0,0,1h1.94v1.94a.5.5,0,0,0,1,0V9.12h1.94a.5.5,0,0,0,0-1Z"></path>
                              <path class="add-money-icon-stroke" d="M33.25,23.82a.5.5,0,0,0-1,.12c0,.12,0,.38,0,.71-4.71-.44-9.35.21-13.84.85s-9.1,1.29-13.75.83l-.5-12.26L4.58,14a.5.5,0,1,0-.16-1l-.81.15a.5.5,0,0,0-.39.51l.53,13.11a.48.48,0,0,0,0,.08.5.5,0,0,0,.43.4,33.6,33.6,0,0,0,3.8.21,75.81,75.81,0,0,0,10.62-1c4.59-.65,9.33-1.32,14.08-.79l.16,0a.5.5,0,0,0,.48-.5s0,0,0,0C33.3,24.57,33.28,24,33.25,23.82Z"></path>
                              <path class="add-money-icon-stroke" d="M33.19,16.5a.5.5,0,0,0-.5.5v4.33c-.46-.09-1.12-.19-2.07-.32a59.87,59.87,0,0,0-14.06.31,34.33,34.33,0,0,1-8.86.26V9.48a24.74,24.74,0,0,0,6.77.13L16,9.51c.09,0,9.06-.82,10-.84a.5.5,0,1,0,0-1c-.94,0-9.67.81-10,.85l-1.51.1A22.27,22.27,0,0,1,7.3,8.38a.5.5,0,0,0-.61.49V22a.5.5,0,0,0,.41.49,18,18,0,0,0,3.38.29,58.59,58.59,0,0,0,6.18-.46A59.15,59.15,0,0,1,30.5,22c1.77.25,3.15.84,3.21-.09l0-4.91A.5.5,0,0,0,33.19,16.5Z"></path>
                              <path class="add-money-icon-stroke" d="M16.9,15.27A3.11,3.11,0,1,0,20,12.16,3.11,3.11,0,0,0,16.9,15.27Zm5.22,0A2.11,2.11,0,1,1,20,13.17,2.11,2.11,0,0,1,22.11,15.27Z"></path>
                          </g>
                      </svg>
                  </a>
                  <h6 class="text-primary text-uppercase">Balance HTG Availlable</h6>
                  <h2 class="m-b-10 ballance"><span data-plugin="counterup">{{wallet.balance.htg | currency('HTG ')}}</span></h2>
              </div>
          </div>
          <div class="col-lg-6 col-md-6">
              <div class="card-box tilebox-two tilebox-success" style="border-left-color: #4bd396;">
                  <a href="#" title="Add money to Lajancash wallet" class="pull-right">
                      <svg class="add-money-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 32" width="65px" height="45px" fill="#20BFD6">
                          <g>
                              <path class="add-money-icon-stroke" d="M34.41,2.57a6.1,6.1,0,0,0-6.13,6.06,6.14,6.14,0,0,0,12.27,0A6.1,6.1,0,0,0,34.41,2.57Zm0,11.11a5.1,5.1,0,0,1-5.13-5.06,5.14,5.14,0,0,1,10.27,0A5.1,5.1,0,0,1,34.41,13.68Z"></path>
                              <path class="cls-1" d="M36.85,8.12H34.91V6.18a.5.5,0,0,0-1,0V8.12H32a.5.5,0,0,0,0,1h1.94v1.94a.5.5,0,0,0,1,0V9.12h1.94a.5.5,0,0,0,0-1Z"></path>
                              <path class="add-money-icon-stroke" d="M33.25,23.82a.5.5,0,0,0-1,.12c0,.12,0,.38,0,.71-4.71-.44-9.35.21-13.84.85s-9.1,1.29-13.75.83l-.5-12.26L4.58,14a.5.5,0,1,0-.16-1l-.81.15a.5.5,0,0,0-.39.51l.53,13.11a.48.48,0,0,0,0,.08.5.5,0,0,0,.43.4,33.6,33.6,0,0,0,3.8.21,75.81,75.81,0,0,0,10.62-1c4.59-.65,9.33-1.32,14.08-.79l.16,0a.5.5,0,0,0,.48-.5s0,0,0,0C33.3,24.57,33.28,24,33.25,23.82Z"></path>
                              <path class="add-money-icon-stroke" d="M33.19,16.5a.5.5,0,0,0-.5.5v4.33c-.46-.09-1.12-.19-2.07-.32a59.87,59.87,0,0,0-14.06.31,34.33,34.33,0,0,1-8.86.26V9.48a24.74,24.74,0,0,0,6.77.13L16,9.51c.09,0,9.06-.82,10-.84a.5.5,0,1,0,0-1c-.94,0-9.67.81-10,.85l-1.51.1A22.27,22.27,0,0,1,7.3,8.38a.5.5,0,0,0-.61.49V22a.5.5,0,0,0,.41.49,18,18,0,0,0,3.38.29,58.59,58.59,0,0,0,6.18-.46A59.15,59.15,0,0,1,30.5,22c1.77.25,3.15.84,3.21-.09l0-4.91A.5.5,0,0,0,33.19,16.5Z"></path>
                              <path class="add-money-icon-stroke" d="M16.9,15.27A3.11,3.11,0,1,0,20,12.16,3.11,3.11,0,0,0,16.9,15.27Zm5.22,0A2.11,2.11,0,1,1,20,13.17,2.11,2.11,0,0,1,22.11,15.27Z"></path>
                          </g>
                      </svg>
                  </a>
                  <h6 class="text-success text-uppercase">Balance USD Availlable</h6>
                  <h2 class="m-b-10 ballance"><span data-plugin="counterup">{{wallet.balance.usd | currency('US ')}}</span></h2>
              </div>
          </div>
      </div>
      </li>
        <div id="loading" style="text-align: center; margin-bottom: 50px;" class="panel-body row-fluid" v-if="loading">
          <svg class="spinner" width="45px" height="45px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
    </ul>
    <div class="alert alert-info fade in" style="text-align:center;" v-show="hasNoWallet">
      <a href="#" class="close" data-dismiss="alert">&times;</a>
      <i aria-hidden="true" style="font-size:23px; float:left;" class="fa fa-exclamation-triangle"></i>
     Click on the + button to Link a wallet to your account and use it as a payment method to pay bills
    </div>
</div>
</template>
<script>
import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import {HTTP} from '../../services/account-services.js'
import { default as swal } from 'sweetalert2'

Vue.use(Vue2Filters)
export default {
  // name: 'wallet',
  components: {
  },
  data() {
    return {
      active: true,
      account: {},
      paymentMethods: {},
      hasNoWallet: false,
      loading: true
    }
  },
  methods: {
    getPaymentMethod() {
      let token = localStorage.getItem('authToken')
      let userId = localStorage.getItem('userId')
      let app = this
      HTTP.get('/accounts/' + userId + '/paymentMethods?access_token=' + token).then(response => {
        app.paymentMethods = response.data
        // console.log(response.data)
        // localStorage.setItem('phone', response.data.wallets.phoneNumber)
        // console.log(response.data.wallets[0].phoneNumber)
        if (response.data.wallets.length === 0) {
          app.hasNoWallet = true
        }
        if (response.data.cards.length === 0) {
          app.hasNoCard = true
        }
        if (response.data.banks.length === 0) {
          app.hasNoBank = true
        }
        if (response.data.gifts.length === 0) {
          app.hasNoGift = true
        }
        app.loading = false
        console.log(response.data)
      }).catch(function (error) {
        console.log(error)
      })
    },
    deleteWallet(id) {
      swal({
        title: 'Are you sure who want to delete this wallet ?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showLoaderOnConfirm: true,
        preConfirm: function () {
          return new Promise(function (resolve, reject) {
            setTimeout(function () {
              resolve(
                HTTP.delete('/wallet/' + id).then(function (response) {
                  // console.log(response)
                })
              )
            }, 1500)
          })
        },
        allowOutsideClick: false
      }).then(() => {
        swal({
          type: 'success',
          title: 'Wallet delete successfully',
          html: 'The Wallet has been deleted !'
        })
        this.getPaymentMethod()
      })
    }
  },
  mounted() {
    this.getPaymentMethod()
  }
}
</script>
<style>
  .list-group-item {
    padding: 3px 10px
  }

  .list-group-item span,
  .list-group-item i {
    margin-right: 10px;
    font-size: 14px;
    color: #337ab7;
  }

  .tilebox-primary {
    border-left-color: #188ae2;
  }

  .tilebox-success {
    border-left-color: #4bd396;
  }

  .tilebox-two {
    border-left: 4px solid #f3f3f3;
    background-color: #f3f3f3;
  }

  .card-box {
    padding: 3px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin-bottom: 20px;
  }

  .col-lg-3 {
    padding-left: 10px;
    padding-right: 10px;
  }

  .row {
    margin-right: -10px;
    margin-left: -10px;
  }

  .tilebox-two i {
    font-size: 45px;
    opacity: 1;
    /*margin-top: 15px;*/
  }

  .text-dark {
    color: #313a46 !important;
  }

  .text-success {
    color: #4bd396 !important;
  }

  .text-primary {
    color: #188ae2 !important;
  }

  .card-box h2 {
    animation: fadeInScale 0.7s ease-in-out;
  }

  .pull-right {
    display: flex;
    justify-content: space-between;
  }

  .ballance span {
    text-align: center;
    font-size: 20px !important;
  }

.pull-right i{
  font-size: 17px;
  margin-top: 5px;;
}
@media (min-width: 480px) {
  .item img{
  padding:5px;
  }
}
@media (max-width: 480px) {
  .item img{
  margin-left: -10px;
  padding-top: 5px;
  padding-bottom: 5px;
  }
  .col-lg-3, .col-xs-12 {
    padding-left: 0;
    padding-right: 0;
  }
}

.segments {
    font-size: 1rem;
    display: flex;
    justify-content: space-between;
    vertical-align: center;
    padding-left: 1.083em;
}
.item{
  font-size: 16px;
}
/* .blueButton{
  font-size: 20px;
} */
</style>



// WEBPACK FOOTER //
// src/components/Wallets/Wallet.vue